import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchUserAPI, updateUserAPI } from '../../services/userService';

const initialState = {
  token: localStorage.getItem('token') || null,
  user: JSON.parse(localStorage.getItem('user')) || null,
  permissions: localStorage.getItem('permissions') || null, // Guardar permiso como string
  loading: false,
  error: null,
};

export const fetchUser = createAsyncThunk('auth/fetchUser', async (userId, { rejectWithValue }) => {
  try {
    const response = await fetchUserAPI(userId);
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Error desconocido');
  }
});

export const editUser = createAsyncThunk('auth/editUser', async (userData, { rejectWithValue }) => {
  try {
    const response = await updateUserAPI(userData);
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Error desconocido');
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action) {
      state.token = action.payload.token;
      state.user = action.payload.user;

      // Verificar si Permisos es un array válido antes de acceder al primer elemento
      const permisosArray = action.payload.user.Permisos || [];
      state.permissions = permisosArray.length > 0 ? permisosArray[0].nombre_permiso : null;

      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('permissions', state.permissions);
    },
    clearToken(state) {
      state.token = null;
      state.user = null;
      state.permissions = null; // Limpiar permiso
      state.loading = false;
      state.error = null;
      
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('permissions');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.user = action.payload;
        const permisosArray = action.payload.Permisos || [];
        state.permissions = permisosArray.length > 0 ? permisosArray[0].nombre_permiso : null; // Acceder al primer permiso
        state.loading = false;
        state.error = null;

        // Guardar en localStorage
        localStorage.setItem('user', JSON.stringify(action.payload));
        localStorage.setItem('permissions', state.permissions);
      })
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Error al obtener el usuario';
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(editUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(editUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Error al actualizar el usuario';
      });
  },
});

export const { setToken, clearToken } = authSlice.actions;

export default authSlice.reducer;
